import { request } from '../http';

type SupportViewResponse = {
  ok: boolean;
  support_mode: boolean;
  organization_id: string | null;
  organization_name: string | null;
  target_user_id: string | null;
  message: string;
};

export type SupportViewResult = {
  ok: boolean;
  supportMode: boolean;
  organizationId: string | null;
  organizationName: string | null;
  targetUserId: string | null;
  message: string;
};

export const supportService = {
  async openView(body: {
    organizationId?: string;
    targetUserId?: string;
    reason: string;
  }): Promise<SupportViewResult> {
    const data = await request<SupportViewResponse>('/support/view', {
      method: 'POST',
      body: JSON.stringify({
        organization_id: body.organizationId,
        target_user_id: body.targetUserId,
        reason: body.reason,
      }),
    });
    return {
      ok: data.ok,
      supportMode: data.support_mode,
      organizationId: data.organization_id,
      organizationName: data.organization_name,
      targetUserId: data.target_user_id,
      message: data.message,
    };
  },
};
